import { render, staticRenderFns } from "./AddNewItemButton.vue?vue&type=template&id=427322d8&scoped=true"
import script from "./AddNewItemButton.vue?vue&type=script&lang=js"
export * from "./AddNewItemButton.vue?vue&type=script&lang=js"
import style0 from "./AddNewItemButton.vue?vue&type=style&index=0&id=427322d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427322d8",
  null
  
)

export default component.exports